import { CONVERT_NEW_PORTFOLIO } from '../ui/constants/convert.constants';

export function defaultCallback(target, cb, /* error */) {
    return {
        target: target, 
        config: {
            callback: function (result) {
                // 之前的这个获取tabName逻辑，在ui改用<gtab>后已不适用了
                // let tabComponent = this.component.findClosestComponent(comp => comp.nodeName === 'tab');
                // let tabName = !!tabComponent ? tabComponent.name : '';
              
                let tabName = '';
                switch (target) {
                  case CONVERT_NEW_PORTFOLIO:
                    tabName = 'convert-tab';
                    break;
                }
              
                cb && cb({btnName:target, result, tabName});
            }
        }
    }
}

export function callbackInterceptor(target, cb, error) {
    return {
        target: target, 
        config: {
            callback: {
                thrown: function(reason){
                    
                    error && error(reason);
                },
                around: function (_this, fn, args) {
                    
                    cb && cb({btnName: target, before:true, willDoFn:()=>{
                        return fn.apply(_this, args);
                    }});
                }
            }
        }
    }
}

/**
 *
 *
 * @param {Array} list: target
 * @param {Function} cb
 * @returns {Array} which contain callback function
 */
function bindCallbacks(list, cb, error, useInterceptor) {
    let callbacks = [];
    callbacks = list.map((target)=>{
        //callbacks.push()
        if(!useInterceptor){
            return defaultCallback(target, cb, error);
        }
        return callbackInterceptor(target, cb, error)
    })
    return callbacks;
}



export default bindCallbacks;